import { useState, useEffect } from 'react';

export const useWebviewMode = () => {
  const [isWebviewMode, setIsWebviewMode] = useState(() => {
    if (typeof window === 'undefined') return false;
    return window.sessionStorage?.getItem('webview_mode') === '1';
  });

  useEffect(() => {
    const handleStorageChange = () => {
      setIsWebviewMode(window.sessionStorage?.getItem('webview_mode') === '1');
    };

    window.addEventListener('storage', handleStorageChange);
    return () => window.removeEventListener('storage', handleStorageChange);
  }, []);

  return isWebviewMode;
};
